export default __webpack_public_path__ + "static/media/LightBlue0007.bac2c359.png";